// https://developer.qiniu.com/dora/api/1279/basic-processing-images-imageview2
export const getThumbnail = (width, height) => {
  const w = width ? `/w/${width}` : ''
  const h = height ? `/h/${height}` : ''
  return `imageView2/2${w}${h}`
}
